<template>
  <el-dialog
    :title="form.id ? '编辑' : '新建'"
    :visible.sync="formVisible"
    width="1100px"
    :close-on-click-modal="false"
  >
    <el-form
      ref="dataForm"
      :rules="formRules"
      :model="form"
      label-position="right"
      size="small"
      label-width="100px"
    >
      <el-card class="box-card">
        <el-descriptions title="内容类型(必填)"></el-descriptions>
        <el-button
          :class="
            item.value === activeType
              ? 'content-type-btn active'
              : 'content-type-btn'
          "
          :disabled="!!form.id"
          v-for="(item, index) in contentTypes"
          :key="index"
          @click="handleContentTypeChange(item.value)"
          >{{ item.label }}</el-button
        >
      </el-card>
      <el-card class="box-card mt10">
        <el-descriptions title="文章基础消息"></el-descriptions>
        <el-form-item label="基础信息" prop="title" class="width100">
          <div style="display: flex;">
            <imageUpload v-model="form.coverImage" width="120" height="80" />
            <div style="margin-left: 10px;width: 100%;">
              <el-form-item prop="title" class="width100">
                <el-input v-model="form.title" placeholder="请输入标题" />
              </el-form-item>
              <el-form-item prop="description" class="width100">
                <el-input v-model="form.description" placeholder="请输入描述" />
              </el-form-item>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="分享海报图片" prop="posterImg" class="width100">
          <moreImageUpload
            v-model="form.posterImg"
            :limit="999"
            hintText="建议尺寸750x750像素以上"
          />
        </el-form-item>
        <el-form-item label="分类" prop="classificationId">
          <treeselect
            v-model="form.classificationId"
            :options="menuOptions"
            :normalizer="normalizer"
            :disable-branch-nodes="true"
            :show-count="true"
            noOptionsText="暂无数据"
            placeholder="请选择"
          />
        </el-form-item>
        <el-form-item label="排序(营销所有-从大到小)" prop="orderNo">
          <el-input v-model="form.orderNo" placeholder="请输入排序值" />
        </el-form-item>
        <el-form-item label="虚拟数据配置" prop="virtualData" class="width100">
          <div class="virtual-data-container">
            <el-form-item label="浏览量: " label-width="70px" prop="browseNum">
              <el-input
                v-model="form.browseNum"
                placeholder="请输入虚拟浏览量"
              />
            </el-form-item>
            <el-form-item label="点赞量: " label-width="70px" prop="likeNum">
              <el-input v-model="form.likeNum" placeholder="请输入虚拟点赞量" />
            </el-form-item>
            <el-form-item label="收藏量: " label-width="70px" prop="collectNum">
              <el-input
                v-model="form.collectNum"
                placeholder="请输入虚拟收藏量"
              />
            </el-form-item>
            <el-form-item label="转发量: " label-width="70px" prop="forwardNum">
              <el-input
                v-model="form.forwardNum"
                placeholder="请输入虚拟转发量"
              />
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item label="状态" prop="state" class="width100">
          <el-switch
            v-model="form.state"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
      </el-card>
      <el-card class="box-card mt10" v-if="activeType === 3">
        <el-descriptions title="其他链接"></el-descriptions>
        <el-form-item label="名称: " label-width="60px" class="width100">
          <el-input v-model="form.otherName" placeholder="请输入名称" />
        </el-form-item>
        <el-form-item label="链接: " label-width="60px" class="width100">
          <el-input
            v-model="form.otherUrl"
            placeholder="请输入链接"
            type="textarea"
            :rows="2"
          />
        </el-form-item>
      </el-card>
      <el-card class="box-card mt10">
        <el-descriptions title="文章详情" />
        <!-- type 1: 单个内容编辑器 -->
        <el-form-item
          label="内容"
          prop="content"
          class="width100"
          v-if="activeType === 1"
        >
          <editor
            :key="editorKey"
            v-model="form.content"
            :min-height="240"
            :height="240"
            :uploadUrl="uploadUrl"
          />
        </el-form-item>
        <!-- type 3: 多个模块（每个模块包含富文本编辑器和文件上传） -->
        <template v-if="activeType === 3">
          <div
            v-for="(module, index) in contentList"
            :key="`module-${index}`"
            class="content-module"
            style="margin-bottom: 20px; padding: 15px; border: 1px solid #e4e7ed; border-radius: 4px;"
          >
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
              <span style="font-weight: bold; color: #303133;">内容 {{ index + 1 }}</span>
              <el-button
                v-if="contentList.length > 1"
                type="danger"
                icon="el-icon-delete"
                size="small"
                @click="removeModule(index)"
              >删除内容</el-button>
            </div>
            <el-form-item
              :label="index === 0 ? '内容' : ''"
              class="width100"
            >
              <editor
                :key="`editor-${index}-${editorKey}`"
                v-model="module.content"
                :min-height="240"
                :height="240"
                :uploadUrl="uploadUrl"
              />
            </el-form-item>
            <el-form-item
              label="上传附件 (选填)"
              class="width100"
            >
              <div style="margin-bottom: 8px; color: #909399; font-size: 12px;">
                上传文件类型: PPT, PDF, word, Excel, 文件夹, 压缩包
              </div>
              <fileUpload
                v-model="module.attachmentFiles"
                file-txt="新增"
                :limit="10"
                limit-type=".ppt,.pptx,.pdf,.doc,.docx,.xls,.xlsx,.zip,.rar,.7z"
                hint-text=""
              />
            </el-form-item>
          </div>
          <el-form-item class="width100">
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addModule"
            >新增内容</el-button>
          </el-form-item>
        </template>
        <!-- type 2: 视频上传 -->
        <el-form-item
          label="视频"
          prop="video"
          class="width100"
          v-if="activeType === 2"
        >
          <fileUpload
            v-model="form.materialImg"
            file-txt="上传视频"
            :limit="10"
            limit-type="video/*"
          />
        </el-form-item>
        <!-- type 2: 视频分享文案 -->
        <el-form-item label="分享文案" class="width100" v-if="activeType === 2">
          <el-input
            v-model="videoCopyText"
            type="textarea"
            :rows="4"
            placeholder="请输入分享文案"
          />
        </el-form-item>
      </el-card>
      <el-card class="box-card mt10" v-if="activeType === 1 || activeType === 2">
        <el-descriptions title="分享素材"></el-descriptions>

        <el-form-item
          label="下载素材权限"
          prop="canDownloadMaterial"
          class="width100"
        >
          <el-radio-group v-model="form.canDownloadMaterial">
            <el-radio :label="0">不允许用户下载素材</el-radio>
            <el-radio :label="1">允许用户下载素材</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="activeType === 1">
          <el-form-item label="分享文案：" class="width100">
            <el-tag
              :key="`tag-${index}`"
              v-for="(tag, index) in dynamicTags"
              closable
              :disable-transitions="false"
              @close="handleClose(tag, index)"
            >
              {{ index + 1 }}、{{ tag }}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showInput"
              >添加文案</el-button
            ></el-form-item
          >
          <el-form-item label="图片" prop="shareImage" class="width100">
            <moreImageUpload
              v-model="form.materialImg"
              :limit="999"
              hintText="建议尺寸750x750像素以上"
            />
          </el-form-item>
        </template>
      </el-card>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doCreate()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import templateClassificationApi from "@/api/marketing/templateClassification";
import templateMaterialsShareApi from "@/api/marketing/templateMaterialsShare";
import ImageUpload from "@/components/ImageUpload";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Editor from "@/components/Editor";
import MoreImageUpload from "@/components/MoreImageUpload";
import FileUpload from "@/components/FileUpload";
function initFormBean() {
  const formBean = {
    id: null,
    classificationId: null,
    classificationCode: "",
    coverImage: null,
    title: null,
    titleJson: null,
    description: null,
    type: 1,
    orderNo: 0,
    state: 1,
    browseNum: null,
    likeNum: null,
    collectNum: null,
    forwardNum: null,
    logolmg: null,
    content: "",
    canDownloadMaterial: null,
    materialImg: [],
    materialText: [],
    otherName: null,
    otherUrl: null,
    meetingId: null,
    contactTime: null,
    contactAddress: null,
    contactName: null,
    contactPho: null,
    teacherId: null,
    teacherIsEdit: 0,
    courseSubjectId: null,
    courseSubjectList: null,
    sourceType: 6,
    attachmentFiles: [],
    // 分享素材图片（多张图片，前端用数组存，提交时转成逗号分隔字符串）
    posterImg: [],
  };
  return formBean;
}

export default {
  components: { ImageUpload, Treeselect, Editor, MoreImageUpload, FileUpload },
  data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + "/sys/cosUploader/upload",
      form: initFormBean(),
      formVisible: false,
      formRules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        contentType: [
          { required: true, message: "请选择内容类型", trigger: "change" }
        ],
        category: [{ required: true, message: "请输入分类", trigger: "blur" }],
        coverImage: [
          { required: true, message: "请上传封面图", trigger: "change" }
        ],
        sortOrder: [
          { pattern: /^[0-9]*$/, message: "排序必须为数字值", trigger: "blur" }
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        browseNum: [{ required: true, message: "请输入虚拟浏览量", trigger: "blur" }],
        likeNum: [{ required: true, message: "请输入虚拟点赞量", trigger: "blur" }],
        collectNum: [{ required: true, message: "请输入虚拟收藏量", trigger: "blur" }],
        forwardNum: [{ required: true, message: "请输入虚拟转发量", trigger: "blur" }]
      },
      isRepSub: false,
      activeType: 1,
      contentTypes: [
        { label: "线上/图文", value: 1 },
        { label: "线上/视频", value: 2 }
        // { label: "线下/文件", value: 3 }
      ],
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      videoCopyText: "",
      menuOptions: [],
      isParentid: false,
      editorKey: 0,
      // type 3 的多个内容列表
      contentList: [],
      // 附件文件列表
      attachmentFiles: []
    };
  },
  created() {
    this.getTreeselect();
  },
  watch: {
    activeType(newVal) {
      // 当切换到 type 3 时，初始化 contentList
      if (newVal === 3) {
        if (!this.contentList || this.contentList.length === 0) {
          this.contentList = [{ content: "", attachmentFiles: [] }];
          this.editorKey += 1;
        }
      } else {
        // 切换到其他类型时，清空 contentList
        this.contentList = [];
      }
    }
  },
  methods: {
    /** 处理内容类型切换 */
    handleContentTypeChange(value) {
      // 编辑模式下不允许更改内容类型
      if (this.form.id) {
        this.$message.warning("编辑模式下不允许更改内容类型");
        return;
      }
      this.activeType = value;
    },
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.childList && !node.childList.length) {
        delete node.childList;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.childList
      };
    },
    /** 查询分类下拉树结构 */
    getTreeselect() {
      templateClassificationApi
        .fetchTreeList({ pageNo: 1, pageSize: 1000, sourceType: 6,state: 1 })
        .then(({ data }) => {
          if (data && data.list) {
            this.menuOptions = data.list;
          } else {
            this.menuOptions = [];
          }
        })
        .catch(err => {
          console.error("获取分类树失败:", err);
          this.menuOptions = [];
        });
    },
    /**
     * 在树结构中根据id查找节点并返回code
     * @param {Array} tree 树结构数组
     * @param {Number|String} id 要查找的id
     * @returns {String|null} 找到的code值，未找到返回null
     */
    findCodeById(tree, id) {
      if (!tree || !Array.isArray(tree) || id === null || id === undefined) {
        return null;
      }
      for (const node of tree) {
        // 比较id，支持数字和字符串类型
        if (node.id === id || node.id === Number(id) || String(node.id) === String(id)) {
          return node.code || null;
        }
        // 递归查找子节点，兼容childList和children两种字段名
        const children = node.childList || node.children;
        if (children && Array.isArray(children) && children.length > 0) {
          const code = this.findCodeById(children, id);
          if (code !== null) {
            return code;
          }
        }
      }
      return null;
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      const inputValue = this.inputValue && this.inputValue.trim();
      if (inputValue) {
        // 检查是否已存在，避免重复
        if (!this.dynamicTags.includes(inputValue)) {
          this.dynamicTags.push(inputValue);
          // 同步到 form.materialText
          if (!this.form.materialText) {
            this.form.materialText = [];
          }
          if (!this.form.materialText.includes(inputValue)) {
            this.form.materialText.push(inputValue);
          }
        } else {
          this.$message.warning("该文案已存在");
        }
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    handleClose(tag, index) {
      // 使用 index 删除，更准确
      if (index !== undefined && index >= 0) {
        this.dynamicTags.splice(index, 1);
        // 同步从 form.materialText 中移除
        if (this.form.materialText && Array.isArray(this.form.materialText)) {
          this.form.materialText.splice(index, 1);
        }
      } else {
        // 如果没有 index，使用值查找
        const tagIndex = this.dynamicTags.indexOf(tag);
        if (tagIndex > -1) {
          this.dynamicTags.splice(tagIndex, 1);
          // 同步从 form.materialText 中移除
          if (this.form.materialText && Array.isArray(this.form.materialText)) {
            const textIndex = this.form.materialText.indexOf(tag);
            if (textIndex > -1) {
              this.form.materialText.splice(textIndex, 1);
            }
          }
        }
      }
    },
    /**
     * 添加模块（type 3）
     */
    addModule() {
      this.contentList.push({
        content: "",
        attachmentFiles: []
      });
      // 更新 editorKey 强制重新渲染新的 Editor 组件
      this.editorKey += 1;
    },
    /**
     * 删除模块（type 3）
     */
    removeModule(index) {
      if (this.contentList.length > 1) {
        this.contentList.splice(index, 1);
        // 更新 editorKey 强制重新渲染 Editor 组件
        this.editorKey += 1;
      } else {
        this.$message.warning("至少需要保留一个模块");
      }
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.isParentid = false;
      this.form = initFormBean();
      this.activeType = 1;
      this.dynamicTags = [];
      this.inputVisible = false;
      this.inputValue = "";
      this.videoCopyText = "";
      // 确保数组字段始终是数组
      this.form.materialImg = [];
      this.form.materialText = [];
      // 确保 content 是空字符串，而不是 null
      this.form.content = "";
      // type 3 的多个模块列表，每个模块包含 content 和 attachmentFiles，初始化为一个空模块
      this.contentList = [{ content: "", attachmentFiles: [] }];
      // 更新 editorKey 强制重新渲染 Editor 组件
      this.editorKey += 1;
        // 分享素材图片重置为空数组
        this.form.posterImg = [];
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.resetForm();
      if (row && row.id) {
        this.form.parentid = row.id;
        this.isParentid = true;
      }
      this.formVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    handleUpdate(row) {
      this.resetForm();
      // 获取 id，优先从 templateMaterialsSharePO 中获取
      const id =
        (row.templateMaterialsSharePO && row.templateMaterialsSharePO.id) ||
        row.id;

      if (!id) {
        this.$message.error("缺少物料ID");
        return;
      }

      // 加载数据
      templateMaterialsShareApi
        .fetchById(id)
        .then(res => {
          const responseData = res.data || {};
          const sharePO =
            responseData.templateMaterialsSharePO || responseData || {};

          // 回填表单数据
          this.form = {
            ...this.form,
            ...sharePO,
            // 处理分类ID
            classificationId: sharePO.classificationId
              ? Number(sharePO.classificationId)
              : null,
            // 处理类型
            type: sharePO.type || 1
          };

          // 设置内容类型
          this.activeType = sharePO.type || 1;

          // 处理标题 JSON
          if (sharePO.titleJson) {
            try {
              const titleList =
                typeof sharePO.titleJson === "string"
                  ? JSON.parse(sharePO.titleJson)
                  : sharePO.titleJson;
              if (Array.isArray(titleList)) {
                this.dynamicTags = titleList
                  .map(item => item.titleName || item)
                  .filter(Boolean);
                // 同步到 materialText
                this.form.materialText = [...this.dynamicTags];
              }
            } catch (e) {
              console.error("解析标题失败:", e);
            }
          }

          // 处理素材数组
          if (sharePO.materialImg) {
            try {
              const parsedImg =
                typeof sharePO.materialImg === "string"
                  ? JSON.parse(sharePO.materialImg)
                  : sharePO.materialImg;
              // 确保是数组，并转换为组件需要的格式
              if (Array.isArray(parsedImg)) {
                this.form.materialImg = parsedImg.map((url, index) => {
                  // 如果已经是对象格式，直接返回
                  if (typeof url === "object" && url.url) {
                    return url;
                  }
                  // 如果是字符串，转换为对象格式
                  return {
                    url: url,
                    name: `image-${index}.jpg`,
                    uid: Date.now() + index
                  };
                });
              } else {
                this.form.materialImg = [];
              }
            } catch (e) {
              console.error("解析素材图片失败:", e);
              this.form.materialImg = [];
            }
          } else {
            this.form.materialImg = [];
          }
          // 处理分享素材图片 posterImg（多张图片以英文逗号或JSON数组形式存）
          if (sharePO.posterImg) {
                    try {
                      let posterImgSource = sharePO.posterImg;
                      let urlList = [];

                      if (typeof posterImgSource === "string") {
                        // 先尝试按 JSON 数组解析
                        try {
                          const parsed = JSON.parse(posterImgSource);
                          if (Array.isArray(parsed)) {
                            urlList = parsed;
                          } else {
                            // 不是数组，则按逗号分隔
                            urlList = posterImgSource
                              .split(",")
                              .map(item => item && item.trim())
                              .filter(Boolean);
                          }
                        } catch (e) {
                          // 不是 JSON，按逗号分隔
                          urlList = posterImgSource
                            .split(",")
                            .map(item => item && item.trim())
                            .filter(Boolean);
                        }
                      } else if (Array.isArray(posterImgSource)) {
                        urlList = posterImgSource;
                      }

                      if (Array.isArray(urlList) && urlList.length > 0) {
                        this.form.posterImg = urlList.map((item, index) => {
                          if (item && typeof item === "object" && item.url) {
                            return item;
                          }
                          const url = typeof item === "string" ? item : "";
                          return {
                            url,
                            name: `poster-${index}.jpg`,
                            uid: Date.now() + index
                          };
                        });
                      } else {
                        this.form.posterImg = [];
                      }
                    } catch (e) {
                      console.error("解析分享素材图片 posterImg 失败:", e);
                      this.form.posterImg = [];
                    }
                  } else {
                    this.form.posterImg = [];
                  }
                  
                  if (sharePO.materialText) {
                    try {
                      const parsedText =
                        typeof sharePO.materialText === "string"
                          ? JSON.parse(sharePO.materialText)
                          : sharePO.materialText;
                      if (sharePO.type === 2) {
                        // type 2: 视频只有一个文案，直接作为字符串
                        this.videoCopyText = Array.isArray(parsedText)
                          ? (parsedText[0] || "")
                          : (typeof parsedText === "string" ? parsedText : "");
                        this.form.materialText = Array.isArray(parsedText)
                          ? parsedText
                          : [];
                      } else {
                        // type 1: 回显到图文分享文案
                        this.form.materialText = Array.isArray(parsedText)
                          ? parsedText
                          : [];
                        if (Array.isArray(parsedText) && parsedText.length > 0) {
                          this.dynamicTags = [...parsedText];
                        }
                      }
                    } catch (e) {
                      this.form.materialText = [];
                    }
                  }

          // 处理内容
          if (sharePO.type === 3) {
            // type 3: 解析 content 字段（JSON 格式），回显到 contentList
            if (sharePO.content) {
              try {
                const parsedContent =
                  typeof sharePO.content === "string"
                    ? JSON.parse(sharePO.content)
                    : sharePO.content;
                
                if (Array.isArray(parsedContent) && parsedContent.length > 0) {
                  // 确保每个模块都有 content 和 attachmentFiles 字段
                  this.contentList = parsedContent.map(item => ({
                    content: item.content || "",
                    attachmentFiles: Array.isArray(item.attachmentFiles)
                      ? item.attachmentFiles.map((file, idx) => {
                          // 如果是字符串，转换为对象格式
                          if (typeof file === "string") {
                            return {
                              url: file,
                              name: file.split("/").pop() || `file-${idx}`,
                              uid: Date.now() + idx
                            };
                          }
                          // 如果已经是对象格式，直接返回
                          return file;
                        })
                      : []
                  }));
                } else {
                  // 如果没有数据，初始化为一个空模块
                  this.contentList = [{ content: "", attachmentFiles: [] }];
                }
                // 更新 editorKey 强制重新渲染 Editor 组件
                this.editorKey += 1;
              } catch (e) {
                console.error("解析内容失败:", e);
                // 解析失败，初始化为一个空模块
                this.contentList = [{ content: "", attachmentFiles: [] }];
                this.editorKey += 1;
              }
            } else {
              // 没有内容，初始化为一个空模块
              this.contentList = [{ content: "", attachmentFiles: [] }];
              this.editorKey += 1;
            }
            // type 3 不需要设置 form.content
            this.form.content = "";
          } else {
            // 其他类型：正常处理 content
            if (sharePO.content) {
              try {
                this.form.content =
                  typeof sharePO.content === "string"
                    ? JSON.parse(sharePO.content)
                    : sharePO.content;
              } catch (e) {
                this.form.content = sharePO.content;
              }
            }
          }

          this.formVisible = true;
          this.$nextTick(() => {
            this.$refs["dataForm"].clearValidate();
          });
        })
        .catch(err => {
          console.error("加载数据失败:", err);
          this.$message.error("加载数据失败");
        });
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      const params = JSON.parse(JSON.stringify(this.form));

      // 设置类型
      params.type = this.activeType;

      // 根据classificationId从backendTreeList中查找对应的code
      if (params.classificationId) {
        const code = this.findCodeById(this.menuOptions, params.classificationId);
        if (code) {
          params.classificationCode = code;
        }
      }

      // 处理标题：如果有多个标题，转换为 titleJson
      if (this.dynamicTags && this.dynamicTags.length > 0) {
        params.titleJson = JSON.stringify(
          this.dynamicTags.map(tag => ({
            titleName: tag,
            isEdit: 0
          }))
        );
      }
      // 分享素材图片 posterImg：多张图片以英文逗号拼接 URL 字符串保存
      if (Array.isArray(params.posterImg) && params.posterImg.length > 0) {
              // posterImg 里是 MoreImageUpload 的文件对象数组，取 url 字段
              const urlList = params.posterImg
                .map(item => {
                  if (!item) return "";
                  if (typeof item === "string") return item.trim();
                  return (item.url || "").trim();
                })
                .filter(Boolean);
              params.posterImg = urlList.length > 0 ? urlList.join(",") : "";
            } else {
              params.posterImg = "";
            }
      // 处理素材数组：转换为 JSON 字符串
      // materialImg 是图片数组
      if (Array.isArray(params.materialImg)) {
        params.materialImg =
          params.materialImg.length > 0
            ? JSON.stringify(params.materialImg)
            : null;
      }
      // materialText 是文案数组，type 2 使用 videoCopyText，其他类型使用 dynamicTags
      if (this.activeType === 2) {
        params.materialText = this.videoCopyText ? JSON.stringify([this.videoCopyText]) : null;
      } else if (this.dynamicTags && this.dynamicTags.length > 0) {
        params.materialText = JSON.stringify(this.dynamicTags);
      } else if (Array.isArray(params.materialText)) {
        params.materialText =
          params.materialText.length > 0
            ? JSON.stringify(params.materialText)
            : null;
      }

      // 处理内容
      if (this.activeType === 3) {
        // type 3: 将 contentList（包含内容和附件）转换为 JSON 存储到 content 字段
        if (this.contentList && this.contentList.length > 0) {
          // 过滤掉空内容，至少保留一个
          const validContentList = this.contentList.filter(
            item => item.content || (item.attachmentFiles && item.attachmentFiles.length > 0)
          );
          if (validContentList.length > 0) {
            params.content = JSON.stringify(validContentList);
          } else {
            // 如果都为空，至少保留一个空模块
            params.content = JSON.stringify([{ content: "", attachmentFiles: [] }]);
          }
        } else {
          params.content = JSON.stringify([{ content: "", attachmentFiles: [] }]);
        }
      } else if (Array.isArray(params.content)) {
        // 其他类型：如果是数组，转换为 JSON 字符串
        params.content =
          params.content.length > 0 ? JSON.stringify(params.content) : null;
      }

      // 处理数字字段
      const toInt = v => {
        if (v === undefined || v === null || v === "") return undefined;
        const n = Number(v);
        return Number.isNaN(n) ? undefined : n;
      };

      const intFields = [
        "classificationId",
        "meetingId",
        "orderNo",
        "state",
        "browseNum",
        "likeNum",
        "collectNum",
        "forwardNum",
        "teacherId",
        "teacherIsEdit",
        "canDownloadMaterial",
        "courseSubjectId",
        "type"
      ];

      intFields.forEach(k => {
        const v = toInt(params[k]);
        if (v === undefined) {
          delete params[k];
        } else {
          params[k] = v;
        }
      });

      // 新增时 id 传 null
      if (!params.id) {
        params.id = null;
      }

      // 清理 undefined 和 null 值（但保留空字符串，因为某些字段可能需要）
      Object.keys(params).forEach(key => {
        if (params[key] === undefined || params[key] === null) {
          delete params[key];
        }
      });

      console.log("提交参数:", params);

      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          if (this.isRepSub) return;
          this.isRepSub = true;

          const req = params.id
            ? templateMaterialsShareApi.update(params)
            : templateMaterialsShareApi.create(params);

          req
            .then(data => {
              this.postCallback(data);
            })
            .catch(res => {
              this.isRepSub = false;
              console.error("操作失败:", res);
              this.$message.error(res.message || "操作失败");
            });
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false;
      this.$message.success("操作成功");
      this.formVisible = false;
      this.$emit("created");
    }
  }
};
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}

.content-type-btn {
  background-color: #f8f8f8;
  border-color: #c5c5c5;
  color: #606266;

  &:hover {
    background-color: #ecf4fd;
    border-color: #3a8ee6;
    color: #3a8ee6;
  }

  &.active {
    background-color: #ecf4fd;
    border-color: #3a8ee6;
    color: #3a8ee6;

    &:hover {
      background-color: #ecf4fd;
      border-color: #3a8ee6;
      color: #3a8ee6;
    }
  }
}

.virtual-data-container {
  display: flex;
  justify-content: space-between;
  gap: 10px;

  .el-input {
    font-size: 12px;

    ::v-deep .el-input__inner {
      font-size: 12px;
    }
  }
}
.el-tag {
  margin-right: 6px;
}
</style>
